import React from 'react';
import {Skeleton} from '@zooplus/ui-components';

const LoadingSkeleton = ({ height = '70px', borderRadius = 0, marginBottom = 30, marginTop = 0 }) => {
  return (
    <Skeleton
      style={{
        marginBottom: marginBottom,
        borderRadius: borderRadius,
        marginTop: marginTop,
        height: height
      }}>
    </Skeleton>
  );
};

export default LoadingSkeleton;
